'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewsletterModals = function NewsletterModals(el) {
  var _this = this;

  (0, _classCallCheck3.default)(this, NewsletterModals);

  this.nowY = window.scrollY || window.pageYOffset;
  this.offset = 1000;

  this.cookieName = 'bao-newsletter-modal';

  this.newsletterModal = (0, _functional.getElement)('[data-modal="newsletter"]');
  this.newsletterSuccessModal = (0, _functional.getElement)('[data-modal="newsletter-success"]');
  this.modalHasBeenShown = false;
  this.isQuizPage = window.location.href.includes('discover-your-hair-dosha');
  this.isResultsPage = ['youre-a-kapha', 'youre-a-pitta', 'youre-a-vata'].some(function (handle) {
    return window.location.href.includes(handle);
  });

  this.shouldShowNewsletterModal = (_jsCookie2.default.get(this.cookieName) === undefined || this.isResultsPage) && this.isQuizPage === false;
  this.shouldShowNewsletterSuccessModal = window.location.href.includes('newsletter&form_type=customer');

  var showNewsletterModal = function showNewsletterModal() {
    window.setTimeout(function () {
      _this.modalHasBeenShown = true;
      _jsCookie2.default.set(_this.cookieName, 'true', {
        expires: 30
      });

      _this.newsletterModal.classList.add('mod-Modal-active');
      var close = (0, _functional.getElement)('[data-modal-close]', {
        context: _this.newsletterModal
      });
      close.addEventListener('click', function () {
        _this.newsletterModal.classList.remove('mod-Modal-active');
      }, 2000);
    });
  };

  if (this.shouldShowNewsletterModal) {
    var mouseoutListener = function mouseoutListener(e) {
      if (e.relatedTarget == null) {
        showNewsletterModal();

        document.removeEventListener('mouseout', mouseoutListener);
      }
    };
    var scrollListener = function scrollListener() {
      var nowY = window.scrollY || window.pageYOffset;
      var nowYMoreThanOffset = nowY >= _this.nowY + _this.offset || nowY <= _this.nowY - _this.offset;
      var shouldShow = nowYMoreThanOffset && _this.modalHasBeenShown === false;

      if (shouldShow) {
        showNewsletterModal();

        window.removeEventListener('scroll', scrollListener);
      }
    };

    if (this.isResultsPage) {
      document.addEventListener('mouseout', mouseoutListener);

      window.addEventListener('scroll', scrollListener, {
        passive: true
      });
    }

    window.addEventListener('scroll', scrollListener, {
      passive: true
    });
  }

  if (this.shouldShowNewsletterSuccessModal) {
    this.newsletterSuccessModal.classList.add('mod-Modal-active');
    var close = (0, _functional.getElement)('[data-modal-close]', {
      context: this.newsletterSuccessModal
    });
    close.addEventListener('click', function () {
      _this.newsletterSuccessModal.classList.remove('mod-Modal-active');
    });
  }
};

exports.default = NewsletterModals;